import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Courier } from '../models/courier';

@Injectable({
  providedIn: 'root',
})
export class CouriersApiService {
  getCouriers(): Observable<Courier[]> {
    return of([
      { name: 'Postnord', weights: environment.couriers.postnord.weights, requiresWeight: true, enabled: true },
      { name: 'DHL', weights: environment.couriers.dhl.weights, requiresWeight: false, enabled: true }
    ]);
  }
}
